export default {
    data() {
        return {
            mountedPopovers: [],
        }
    },

    beforeDestroy() {
        this.mountedPopovers.forEach(mounted => {
            this.unmountPopover(mounted.element)
        })
    },

    methods: {
        destroyPopovers() {
            this.mountedPopovers.forEach(mounted => {
                this.unmountPopover(mounted.element)
            })
        },

        popover(target, content, options, duration) {
            let element = $(target)

            duration = typeof duration === 'undefined' ? 5000 : duration
            options = typeof options === 'undefined' ? {} : options
            options = Object.assign(
                {
                    content: content,
                    trigger: 'manual',
                    html: true,
                },
                options
            )

            this.unmountPopover(element).then(() => this.mountPopover(element, options, duration))
        },

        mountPopover(element, options, duration) {
            element.popover(options)
            element.popover('show')

            this.mountedPopovers.push({
                element: element,
                timeout: setTimeout(() => this.unmountPopover(element), duration),
            })
        },

        unmountPopover(element) {
            return new Promise(done => {
                this.mountedPopovers.forEach((mounted, index) => {
                    if (mounted.element.get(0) === element.get(0)) {
                        element.popover('destroy')

                        delete this.mountedPopovers[index]

                        clearTimeout(mounted.timeout)
                    }
                })

                done()
            })
        },
    },
}
